var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNotify } from "react-admin";
import { useMutation, useQuery } from "@apollo/client";
import { Box, Button, CircularProgress, Menu, MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckIcon from "@mui/icons-material/Check";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import RuleIcon from "@mui/icons-material/Rule";
import { Dialog } from "@sequentech/ui-essentials";
import { AuthContext } from "@/providers/AuthContextProvider";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { GET_APPROVAL_MATRIX } from "@/queries/GetApprovalMatrix";
import { SAVE_APPROVAL_MATRIX } from "@/queries/SaveApprovalMatrix";
import { USER_PROFILE_ATTRIBUTES } from "@/queries/GetUserProfileAttributes";
import { getAttributeLabel } from "@/services/UserService";
import { IApplicationsStatus } from "@/types/applications";
import { IPermissions } from "@/types/keycloak";
import { ApprovalMatrixRuleDialog } from "./ApprovalMatrixRuleDialog";
import { ApprovalMatrixRules } from "./ApprovalMatrixRules";
import { ApprovalMatrixTest } from "./ApprovalMatrixTest";
import { convertToCamelCase } from "./UtilsApprovals";
import { EMatrixError, EMatrixSource, addRule, cleanMatrix, deleteRule, matrixChanges, moveRule, profileFieldLabel, readMatrix, replaceRule, sameMatrix, validateMatrix, withComparedFields, } from "./approvalMatrix";
import { AccentTag, Card, CardIcon, CardTitle, Help, Muted, Notice, NoticeTitle, Overline, Page, Segment, Tag, TagRow, } from "./approvalStyles";
var NEW_RULE = { when: {}, then: { decision: IApplicationsStatus.PENDING } };
var BackLink = styled("button")(function (_a) {
    var theme = _a.theme;
    return ({
        "display": "inline-flex",
        "alignItems": "center",
        "gap": "8px",
        "padding": "4px 8px 4px 0",
        "border": 0,
        "background": "none",
        "color": theme.palette.brandColor,
        "fontFamily": "inherit",
        "fontSize": "15px",
        "fontWeight": 600,
        "cursor": "pointer",
        "&:focus-visible": { outline: "2px solid ".concat(theme.palette.brandSuccess) },
    });
});
var Columns = styled("div")(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: "grid",
            gridTemplateColumns: "minmax(0, 1fr) 340px",
            gap: "24px",
            alignItems: "start",
            marginTop: "24px"
        },
        _b[theme.breakpoints.down("lg")] = {
            gridTemplateColumns: "minmax(0, 1fr)",
        },
        _b);
});
var SaveBar = styled("div")(function (_a) {
    var theme = _a.theme;
    return ({
        position: "sticky",
        bottom: "16px",
        zIndex: 2,
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        marginTop: "24px",
        padding: "16px 20px",
        borderRadius: "12px",
        border: "1px solid #E3E7EF",
        background: theme.palette.white,
        boxShadow: "0 8px 24px rgba(15, 5, 76, 0.16)",
    });
});
export var ApprovalMatrix = function (_a) {
    var _b;
    var electionEventId = _a.electionEventId, goBack = _a.goBack, cameFrom = _a.cameFrom;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var notify = useNotify();
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    var canEdit = authContext.isAuthorized(true, tenantId, IPermissions.APPROVAL_MATRIX_WRITE);
    var _d = useQuery(GET_APPROVAL_MATRIX, {
        variables: { electionEventId: electionEventId },
        fetchPolicy: "network-only",
    }), data = _d.data, loading = _d.loading, error = _d.error;
    var userAttributes = useQuery(USER_PROFILE_ATTRIBUTES, { variables: { tenantId: tenantId, electionEventId: electionEventId } }).data;
    var _e = useMutation(SAVE_APPROVAL_MATRIX), saveMatrix = _e[0], saving = _e[1].loading;
    var _f = useState(null), current = _f[0], setCurrent = _f[1];
    var _g = useState(null), draft = _g[0], setDraft = _g[1];
    var _h = useState(null), editing = _h[0], setEditing = _h[1];
    var _j = useState(false), confirmSave = _j[0], setConfirmSave = _j[1];
    var _k = useState(undefined), appliesTo = _k[0], setAppliesTo = _k[1];
    var _l = useState([]), offered = _l[0], setOffered = _l[1];
    var _m = useState(null), detailMenu = _m[0], setDetailMenu = _m[1];
    useEffect(function () {
        if (data === null || data === void 0 ? void 0 : data.get_approval_matrix) {
            setCurrent(data.get_approval_matrix);
            setDraft(readMatrix(data.get_approval_matrix.matrix));
        }
    }, [data]);
    var saved = useMemo(function () { return (current ? readMatrix(current.matrix) : null); }, [current]);
    var profileAttributes = userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes;
    var fieldLabel = useMemo(function () { return profileFieldLabel(profileAttributes !== null && profileAttributes !== void 0 ? profileAttributes : [], t, getAttributeLabel); }, [profileAttributes, t]);
    var profileFields = useMemo(function () {
        return (profileAttributes !== null && profileAttributes !== void 0 ? profileAttributes : [])
            .map(function (attribute) { var _a; return convertToCamelCase((_a = attribute.name) !== null && _a !== void 0 ? _a : ""); })
            .filter(function (name) { return name; });
    }, [profileAttributes]);
    var onResult = useCallback(function (rule) { return setAppliesTo(rule); }, []);
    if (loading) {
        return _jsx(CircularProgress, { "aria-label": String(t("approvalsScreen.matrix.title")) });
    }
    var back = (_jsxs(BackLink, { type: "button", onClick: goBack, children: [_jsx(ArrowBackIcon, { fontSize: "small" }), t("approvalsScreen.matrix.back")] }));
    if (error || !current || !draft || !saved) {
        return (_jsxs(Page, { children: [back, _jsx(Notice, { "data-tone": "error", role: "alert", sx: { marginTop: "16px" }, children: t("approvalsScreen.matrix.loadError") })] }));
    }
    var changed = !sameMatrix(draft, saved);
    var problems = validateMatrix(draft);
    var changes = changed ? matrixChanges(saved, draft, t, fieldLabel) : [];
    var brokenRules = new Set(problems.map(function (_a) {
        var rule = _a.rule;
        return rule;
    })).size;
    // The details offered to compare: those of the saved version and any added since.
    var details = __spreadArray(__spreadArray(__spreadArray([], saved.compared_fields, true), draft.compared_fields, true), offered, true).filter(function (field, index, fields) { return fields.indexOf(field) === index; });
    var otherDetails = profileFields.filter(function (field) { return !details.includes(field); });
    var toggleDetail = function (field) {
        return setDraft(withComparedFields(draft, draft.compared_fields.includes(field)
            ? draft.compared_fields.filter(function (compared) { return compared !== field; })
            : details.filter(function (detail) { return detail === field || draft.compared_fields.includes(detail); })));
    };
    var applyRule = function (rule) {
        if (rule && editing) {
            setDraft(editing.isOtherwise
                ? __assign(__assign({}, draft), { otherwise: rule.then }) : editing.index === null
                ? addRule(draft, rule)
                : replaceRule(draft, editing.index, rule));
        }
        setEditing(null);
    };
    var save = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, savedVersion, matrix, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setConfirmSave(false);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, saveMatrix({
                            variables: { electionEventId: electionEventId, matrix: cleanMatrix(draft) },
                        })];
                case 2:
                    result = (_b.sent()).data;
                    savedVersion = result === null || result === void 0 ? void 0 : result.save_approval_matrix;
                    matrix = readMatrix(savedVersion === null || savedVersion === void 0 ? void 0 : savedVersion.matrix);
                    if (!savedVersion || !matrix) {
                        notify(t("approvalsScreen.matrix.save.error"), { type: "error" });
                        return [2 /*return*/];
                    }
                    setCurrent(savedVersion);
                    setDraft(matrix);
                    setOffered([]);
                    notify(t("approvalsScreen.matrix.save.success", { version: savedVersion.version }), {
                        type: "success",
                    });
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    notify(t("approvalsScreen.matrix.save.error"), { type: "error" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var savedOn = current.created_at
        ? new Date(current.created_at).toLocaleString(i18n.language, {
            dateStyle: "medium",
            timeStyle: "short",
        })
        : "-";
    return (_jsxs(Page, { children: [back, _jsxs(Box, { sx: {
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    gap: "16px",
                    marginTop: "16px",
                }, children: [_jsxs(Box, { sx: { maxWidth: "460px" }, children: [_jsx(Box, { component: "h2", sx: { margin: "0 0 8px", fontSize: "26px", fontWeight: 600 }, children: t("approvalsScreen.matrix.title") }), _jsx(Muted, { children: t("approvalsScreen.matrix.subtitle") })] }), _jsxs(Box, { sx: { textAlign: "right" }, children: [_jsxs(TagRow, { sx: { justifyContent: "flex-end", marginBottom: "8px" }, children: [_jsx(AccentTag, { children: t("approvalsScreen.matrix.versionChip", { version: current.version }) }), changed && (_jsx(Tag, { sx: {
                                            background: "#FFF3CD",
                                            borderColor: "#F0D58C",
                                            color: "#7A5200",
                                        }, children: t("approvalsScreen.matrix.unsaved") })), !canEdit && (_jsxs(Tag, { children: [_jsx(LockOutlinedIcon, { sx: { fontSize: "16px" }, "aria-hidden": true }), t("approvalsScreen.matrix.viewOnly")] }))] }), _jsx(Muted, { children: current.source === EMatrixSource.SAVED
                                    ? t("approvalsScreen.matrix.savedBy", {
                                        date: savedOn,
                                        user: (_b = current.created_by) !== null && _b !== void 0 ? _b : "-",
                                    })
                                    : t("approvalsScreen.matrix.builtIn") })] })] }), !canEdit && (_jsxs(Notice, { "data-tone": "info", sx: { marginTop: "24px" }, children: [_jsx(LockOutlinedIcon, { "aria-hidden": true }), _jsxs("div", { children: [_jsx(NoticeTitle, { children: t("approvalsScreen.matrix.readOnlyTitle") }), t("approvalsScreen.matrix.readOnlyText")] })] })), _jsxs(Columns, { children: [_jsxs(Box, { sx: { display: "flex", flexDirection: "column", gap: "24px" }, children: [_jsxs(Card, { "aria-labelledby": "approval-matrix-compared", children: [_jsxs(CardTitle, { id: "approval-matrix-compared", children: [_jsx(CardIcon, { children: _jsx(FactCheckIcon, { fontSize: "small" }) }), t("approvalsScreen.matrix.compared")] }), _jsx(Help, { children: t("approvalsScreen.matrix.comparedHelp") }), _jsxs(TagRow, { role: "group", "aria-label": String(t("approvalsScreen.matrix.compared")), children: [details.map(function (field) {
                                                var compared = draft.compared_fields.includes(field);
                                                return (_jsxs(Segment, { type: "button", "aria-pressed": compared, disabled: !canEdit, onClick: function () { return toggleDetail(field); }, sx: {
                                                        "display": "inline-flex",
                                                        "alignItems": "center",
                                                        "gap": "6px",
                                                        "padding": "8px 14px",
                                                        "borderRadius": "8px",
                                                        "&[aria-pressed='true']": {
                                                            background: "#ECEEFB",
                                                            borderColor: "#C9CEF2",
                                                            color: "#0F054C",
                                                        },
                                                        "&:disabled": { opacity: 1 },
                                                    }, children: [compared && (_jsx(CheckIcon, { sx: { fontSize: "18px" }, "aria-hidden": true })), fieldLabel(field)] }, field));
                                            }), canEdit && otherDetails.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "secondary", size: "small", startIcon: _jsx(AddIcon, {}), "aria-haspopup": "menu", onClick: function (event) { return setDetailMenu(event.currentTarget); }, sx: { minHeight: "38px" }, children: t("approvalsScreen.matrix.addCompared") }), _jsx(Menu, { anchorEl: detailMenu, open: detailMenu !== null, onClose: function () { return setDetailMenu(null); }, children: otherDetails.map(function (field) { return (_jsx(MenuItem, { onClick: function () {
                                                                setDetailMenu(null);
                                                                setOffered(__spreadArray(__spreadArray([], offered, true), [field], false));
                                                                setDraft(withComparedFields(draft, __spreadArray(__spreadArray([], draft.compared_fields, true), [
                                                                    field,
                                                                ], false)));
                                                            }, children: fieldLabel(field) }, field)); }) })] }))] }), problems.some(function (_a) {
                                        var code = _a.code;
                                        return code === EMatrixError.NO_COMPARED_FIELDS;
                                    }) && (_jsx(Notice, { "data-tone": "error", role: "alert", sx: { marginTop: "16px" }, children: t("approvalsScreen.matrix.errors.".concat(EMatrixError.NO_COMPARED_FIELDS)) }))] }), _jsxs(Card, { "aria-labelledby": "approval-matrix-rules", children: [_jsxs(CardTitle, { id: "approval-matrix-rules", children: [_jsx(CardIcon, { sx: { background: "#E3F4EC", color: "#0B6B43" }, children: _jsx(RuleIcon, { fontSize: "small" }) }), t("approvalsScreen.matrix.rules")] }), _jsx(Help, { children: t("approvalsScreen.matrix.rulesHelp") }), _jsx(ApprovalMatrixRules, { matrix: draft, canEdit: canEdit, fieldLabel: fieldLabel, appliesTo: appliesTo, cameFrom: cameFrom && cameFrom.version === current.version && !changed
                                            ? cameFrom.rule
                                            : undefined, problems: problems, onEdit: function (index) {
                                            return setEditing(index === null
                                                ? {
                                                    index: index,
                                                    isOtherwise: true,
                                                    rule: { when: {}, then: draft.otherwise },
                                                }
                                                : { index: index, isOtherwise: false, rule: draft.rules[index] });
                                        }, onMove: function (index, offset) { return setDraft(moveRule(draft, index, offset)); }, onDelete: function (index) { return setDraft(deleteRule(draft, index)); }, onAdd: function () {
                                            return setEditing({ index: null, isOtherwise: false, rule: NEW_RULE });
                                        } })] })] }), _jsxs(Card, { "aria-labelledby": "approval-matrix-example", sx: { position: { lg: "sticky" }, top: { lg: "16px" } }, children: [_jsxs(CardTitle, { id: "approval-matrix-example", children: [_jsx(CardIcon, { children: _jsx(PlayCircleOutlineIcon, { fontSize: "small" }) }), t("approvalsScreen.matrix.test")] }), _jsx(ApprovalMatrixTest, { electionEventId: electionEventId, matrix: draft, validIds: current.valid_ids, fieldLabel: fieldLabel, onResult: onResult })] })] }), canEdit && changed && (_jsxs(SaveBar, { role: "region", "aria-label": String(t("approvalsScreen.matrix.unsaved")), children: [_jsxs("div", { children: [_jsx(NoticeTitle, { children: t("approvalsScreen.matrix.saveBar.title") }), _jsx(Muted, { children: problems.length > 0
                                    ? t("approvalsScreen.matrix.saveBar.fix", { count: brokenRules })
                                    : changes.length > 1
                                        ? "".concat(changes[0], " \u00B7 ").concat(t("approvalsScreen.matrix.saveBar.more", {
                                            count: changes.length - 1,
                                        }))
                                        : changes[0] })] }), _jsxs(Box, { sx: { display: "flex", gap: "12px" }, children: [_jsx(Button, { variant: "cancel", onClick: function () {
                                    setDraft(saved);
                                    setOffered([]);
                                }, children: t("approvalsScreen.matrix.discard") }), _jsx(Button, { disabled: problems.length > 0 || saving, onClick: function () { return setConfirmSave(true); }, children: t("approvalsScreen.matrix.save.button", {
                                    version: current.next_version,
                                }) })] })] })), editing && (_jsx(ApprovalMatrixRuleDialog, { open: true, rule: editing.rule, number: editing.index === null ? null : editing.index + 1, isOtherwise: editing.isOtherwise, comparedFields: draft.compared_fields, validIds: current.valid_ids, fieldLabel: fieldLabel, onClose: applyRule })), _jsxs(Dialog, { variant: "info", open: confirmSave, title: String(t("approvalsScreen.matrix.save.title", { version: current.next_version })), ok: String(t("approvalsScreen.matrix.save.confirm", { version: current.next_version })), cancel: String(t("common.label.cancel")), handleClose: function (result) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!result) return [3 /*break*/, 2];
                                return [4 /*yield*/, save()];
                            case 1:
                                _a.sent();
                                return [3 /*break*/, 3];
                            case 2:
                                setConfirmSave(false);
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); }, children: [_jsx("p", { children: t("approvalsScreen.matrix.save.body") }), _jsx(Notice, { "data-tone": "neutral", children: _jsxs("div", { children: [_jsx(Overline, { sx: { margin: "0 0 4px" }, children: t("approvalsScreen.matrix.save.changes") }), _jsx(Box, { component: "ul", sx: { margin: 0, paddingLeft: "20px" }, children: changes.map(function (change) { return (_jsx("li", { children: change }, change)); }) })] }) }), _jsx(Box, { component: "p", sx: { marginBottom: 0 }, children: _jsx(Muted, { children: t("approvalsScreen.matrix.save.log") }) })] })] }));
};
